export enum ExpressionComparison {
  EQUALS = 'EQUALS',
}

const comparisonMap = {
  EQUALS: '==',
};

export const comparisonToLogicalString = (
  comparison?: ExpressionComparison
): string => {
  return comparison ? comparisonMap[comparison] : '?';
};
